export const addToCart = (product, month) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'ADD_TO_CART',
      product,
      month
    });
    const isAuthenticated = getState().auth.isAuthenticated
    if (isAuthenticated) {
      let cart = getState().cart
      let headers = { "Content-Type": "application/json",};
      let body = JSON.stringify({cart});
      const token = getState().auth.token;
      if (token) {
        headers["Authorization"] = `Token ${token}`;
      }
      return fetch("/api/cart", {headers, body, method: "POST",})
        .then(res => {return res})
    }
  }
}

export const addQuantity = (detailId, month) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'ADD_QUANTITY',
      detailId,
      month
    });
    const isAuthenticated = getState().auth.isAuthenticated
    if (isAuthenticated) {
      let cart = getState().cart
      let headers = { "Content-Type": "application/json",};
      let body = JSON.stringify({cart});
      const token = getState().auth.token;
      if (token) {
        headers["Authorization"] = `Token ${token}`;
      }
      return fetch("/api/cart", {headers, body, method: "POST",})
        .then(res => {return res})
    }
  }
}

export const reduceQuantity = (product_id, month) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'REDUCE_QUANTITY',
      product_id,
      month
    })
    const approvedWarning = getState().shop.approvedWarning
    const isAuthenticated = getState().auth.isAuthenticated
    if (isAuthenticated && approvedWarning) {
      let cart = getState().cart
      let headers = { "Content-Type": "application/json",};
      let body = JSON.stringify({cart});
      const token = getState().auth.token;
      if (token) {
        headers["Authorization"] = `Token ${token}`;
      }
      return fetch("/api/cart", {headers, body, method: "POST",})
        .then(res => {return res})
    }
  }
}

export const sendCart = () => {
  return (dispatch, getState) => {
    let cart = getState().cart
    let headers = { "Content-Type": "application/json",};
    let body = JSON.stringify({cart});
    const token = getState().auth.token;
    if (token) {
      headers["Authorization"] = `Token ${token}`;
    }
    return fetch("/api/cart", {headers, body, method: "POST",})
      .then(res => {return res})
  }
}



// WEBPACK FOOTER //
// ./src/actions/cart.js